<script setup lang="ts">
import {BadgeCheck} from "@lucide/vue";

/**
 * Marks a collaborator habilitated for the act at hand. A preference, never a
 * gate: it sits next to a name that stays selectable either way.
 */
</script>

<template>
  <span class="inline-flex shrink-0 items-center gap-1 rounded-full bg-secondary-lightest px-2 py-0.5 text-xs font-medium text-secondary-darkest">
    <BadgeCheck class="size-3" />
    Habilité
  </span>
</template>
